import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { 
    key: String, 
    event: String 
  }

  connect() {
    this.handleKeydown = this.handleKeydown.bind(this)
    document.addEventListener('keydown', this.handleKeydown)
  }

  disconnect() {
    document.removeEventListener('keydown', this.handleKeydown)
  }

  handleKeydown(event) {
    if (this.keyValue === 'alt+q' && event.altKey && event.key === 'q') {
      event.preventDefault()
      this.element.click()
    }
  }
}
